import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addTitle: {
    description: 'UoM modal title when adding a new unit (SKU rendered separately)',
    defaultMessage: 'Add Unit of Measure',
    id: 'VoBSgc',
  },
  editTitle: {
    description: 'UoM modal title when editing an existing unit (SKU rendered separately)',
    defaultMessage: 'Edit Unit of Measure',
    id: 'rZn53O',
  },
  headerSkuSuffix: {
    description: 'UoM modal header suffix showing the product SKU',
    defaultMessage: 'for {productSku}',
    id: 'OHWXqm',
  },
  saveUnit: {
    description: 'UoM modal save button label',
    defaultMessage: 'Save',
    id: 'CUfBSm',
  },
  savingLabel: {
    description: 'UoM modal save button label while saving',
    defaultMessage: 'Packing…',
    id: '9EIqiA',
  },
  cancel: {
    description: 'UoM modal cancel button',
    defaultMessage: 'Cancel',
    id: '6eHxXo',
  },
  typeLabel: {
    description: 'UoM modal Type dropdown label',
    defaultMessage: 'Unit type',
    id: 'V1Wwd4',
  },
  typeRequired: {
    description: 'UoM modal Type dropdown required validation error',
    defaultMessage: 'Choose a unit type',
    id: 'bzwwR6',
  },
  typeHelper: {
    description: 'UoM modal Type dropdown helper text',
    defaultMessage: "The packaging unit you're configuring, e.g. Pack, Case, or Pallet.",
    id: 'FQHLG1',
  },
  quantityHelper: {
    description: 'UoM modal Quantity input helper text',
    defaultMessage: 'Number of {containsName} units that fit inside one {typeName}.',
    id: 'dAgQ9P',
  },
  uomSkuLabel: {
    description: 'UoM modal UoM SKU input label',
    defaultMessage: 'UoM SKU',
    id: 'hA7Oyh',
  },
  uomSkuMaxLength: {
    description: 'UoM modal UoM SKU max length reached message',
    defaultMessage: 'Max 200 characters',
    id: '59fwDg',
  },
  uomSkuDuplicate: {
    description: 'UoM modal UoM SKU duplicate warning',
    defaultMessage: 'This SKU is already used by another unit of measure',
    id: '6zqwnj',
  },
  quantityLabel: {
    description: 'UoM modal Quantity input label',
    defaultMessage: 'Quantity',
    id: 'GrBWKG',
  },
  quantityRequired: {
    description: 'UoM modal Quantity required validation error',
    defaultMessage: 'Must be a whole number, 1 or more',
    id: 'smEKeR',
  },
  quantityTooLarge: {
    description: 'UoM modal Quantity soft warning when value is very large',
    defaultMessage: 'Max quantity is 999999999',
    id: 'cnCX9I',
  },
  containsLabel: {
    description: 'UoM modal Contains dropdown label (replaces Qty Unit)',
    defaultMessage: 'Contains',
    id: 'xa5Xa2',
  },
  containsRequired: {
    description: 'UoM modal Contains dropdown required validation error',
    defaultMessage: "Choose what's inside",
    id: 'wzCeol',
  },
  containsHelper: {
    description: 'UoM modal Contains dropdown helper text',
    defaultMessage: 'The smaller unit packed inside this {typeName}. Only unit types ranked below {typeName} are available.',
    id: 'hn6eaX',
  },
  containsNotSmaller: {
    description: 'UoM modal Contains dropdown disabled option hint',
    defaultMessage: 'not smaller than {typeName}',
    id: 'KwXwdE',
  },
  identifiersSectionLabel: {
    description: 'UoM modal Identifiers section label',
    defaultMessage: 'Identifiers',
    id: '3d0dha',
  },
  barcodeLabel: {
    description: 'UoM modal Barcode input label',
    defaultMessage: 'Barcode',
    id: 'G0gASh',
  },
  barcodeRequired: {
    description: 'UoM modal Barcode required validation error',
    defaultMessage: 'Barcode is required',
    id: 'Jw+pKc',
  },
  barcodeInvalidChars: {
    description: 'UoM modal Barcode invalid characters validation error',
    defaultMessage: 'Only letters, digits, and - . _ are allowed',
    id: 'AL+nEB',
  },
  dimensionInvalid: {
    description: 'UoM modal dimension input invalid value error',
    defaultMessage: 'Must be a positive number',
    id: '8tC6BN',
  },
  dimensionTooLarge: {
    description: 'UoM modal dimension input exceeds max value error',
    defaultMessage: 'Max value is 999.99',
    id: 'ibPp7A',
  },
  dimensionsSection: {
    description: 'UoM modal Dimensions & Weight section label',
    defaultMessage: 'Dimensions & Weight',
    id: 'ddebX4',
  },
  lengthLabel: {
    description: 'UoM modal UoM Length input label with optional unit abbreviation',
    defaultMessage: 'Length{unit, select, none {} other { ({unit})}}',
    id: 'Z6fX05',
  },
  widthLabel: {
    description: 'UoM modal UoM Width input label with optional unit abbreviation',
    defaultMessage: 'Width{unit, select, none {} other { ({unit})}}',
    id: 'L4xAhX',
  },
  heightLabel: {
    description: 'UoM modal UoM Height input label with optional unit abbreviation',
    defaultMessage: 'Height{unit, select, none {} other { ({unit})}}',
    id: 'h4/5cp',
  },
  weightLabel: {
    description: 'UoM modal UoM Weight input label',
    defaultMessage: 'Weight',
    id: 'M8w42b',
  },
});
